import instance from '../instance';

const getLiveElement = (elementId) =>
  instance.driver
    .getLiveDocument()
    .querySelector(`[${instance.config.referenceAttribute}="${elementId}"]`);

export default getLiveElement;
